
export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Professional',
      description: 'New Jersey registered car rental company providing reliable service like industry leaders Budget and Avis.'
    },
    {
      icon: 'ri-car-line',
      title: 'Quality Fleet',
      description: 'Well-maintained vehicles from top manufacturers, regularly serviced and thoroughly cleaned for your safety.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Convenient Location',
      description: 'Centrally located in East Brunswick, NJ with easy access to major highways and airports.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitive Rates',
      description: 'Professional service at competitive prices with transparent pricing and no hidden fees.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Personal Service',
      description: 'Dedicated customer support and personalized attention for all your rental needs.'
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Full Coverage',
      description: 'Comprehensive insurance options and damage protection for complete peace of mind.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Why Choose Car2Go?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            As a licensed New Jersey car rental company, we provide the same professional service 
            and reliability you expect from established brands like Budget, Avis, and Enterprise.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-600 rounded-2xl p-8 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Business & Corporate Rentals</h3>
          <p className="text-xl mb-6 text-blue-100">
            Professional car rental services for businesses, organizations, and corporate clients
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div className="bg-white/10 rounded-lg p-6">
              <h4 className="text-lg font-semibold mb-2">Business Rates</h4>
              <p className="text-blue-100">Special pricing for corporate accounts and repeat customers</p>
            </div>
            <div className="bg-white/10 rounded-lg p-6">
              <h4 className="text-lg font-semibold mb-2">Professional Service</h4>
              <p className="text-blue-100">Dedicated support for business and corporate clients</p>
            </div>
            <div className="bg-white/10 rounded-lg p-6">
              <h4 className="text-lg font-semibold mb-2">Flexible Terms</h4>
              <p className="text-blue-100">Corporate billing, expense reporting, and flexible rental periods</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
